"use client";
import type { Dispatch, ReactElement, SetStateAction } from "react";
import { GANTT_STATUS_COLORS } from "./gantt-constants";
import { selectTaskInteractionState } from "./gantt-render-selectors";
import type { GanttTaskLayout } from "./gantt-types";
import { GanttBar } from "./GanttBar";
import { GanttMilestone } from "./GanttMilestone";
export interface GanttTaskMarkerProps {
    ganttIdPrefix: string;
    taskLayout: GanttTaskLayout;
    rowIndex: number;
    hoveredTaskId: string | null;
    highlightedTaskIds: ReadonlySet<string>;
    onHoveredTaskIdChange: Dispatch<SetStateAction<string | null>>;
}
export function GanttTaskMarker({ ganttIdPrefix, taskLayout, rowIndex, hoveredTaskId, highlightedTaskIds, onHoveredTaskIdChange, }: GanttTaskMarkerProps): ReactElement {
    const statusColor = GANTT_STATUS_COLORS[taskLayout.task.status];
    const interactionState = selectTaskInteractionState({
        taskId: taskLayout.task.id,
        hoveredTaskId,
        highlightedTaskIds,
    });
    const gradientId = `${ganttIdPrefix}-gradient-${taskLayout.task.status}`;
    const patternId = `${ganttIdPrefix}-pattern-${taskLayout.task.status}`;
    const glowFilterId = `${ganttIdPrefix}-barGlow`;
    return (
      <g data-el="Cmarkdowngantt/TaskMarker/Entry" onMouseEnter={() => onHoveredTaskIdChange(taskLayout.task.id)} onMouseLeave={() => onHoveredTaskIdChange((currentHoveredTaskId) => {
            return currentHoveredTaskId === taskLayout.task.id
                ? null
                : currentHoveredTaskId;
        })} style={{ cursor: "pointer" }}>
        <GanttBar taskLayout={taskLayout} color={statusColor} gradientId={gradientId} patternId={patternId} glowFilterId={glowFilterId} isDimmed={interactionState.isDimmed} isHovered={interactionState.isHovered} rowIndex={rowIndex}/>
        <GanttMilestone taskLayout={taskLayout} color={statusColor} glowFilterId={glowFilterId} isDimmed={interactionState.isDimmed} isHovered={interactionState.isHovered} rowIndex={rowIndex}/>
      </g>
    );
}
